import React from "react";


const DotPulse = () => {
    return <div className="dot-pulse"></div>;
};

export default DotPulse;
